(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("onlineExamLeanerAccessSelectExamSession", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/learnerAccess/learningItemType/onlineExamLeanerAccessSelectExamSessionView.html",
            controller: ["assignmentLearnerAccessOnlineExamResource", "frameworkService", "$state", "$scope", "$uibModal", "messageService", "$translate", "_", OnlineExamLeanerAccessSelectExamSessionCtrl],
            controllerAs: "vm"
        };
        function OnlineExamLeanerAccessSelectExamSessionCtrl(assignmentLearnerAccessOnlineExamResource, frameworkService, $state, $scope, $uibModal, messageService, $translate, _) {
            var vm = this;
            vm.assignmentId = $state.params.assignmentId;
            vm.number = $state.params.number;
            vm.version = $state.params.version;
            vm.code = $state.params.code;
            vm.examTypes = [{ name: "online", value: 1 }, { name: "inPerson", value: 0 }];
            vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
            vm.filters = {
                city: { value: "" },
                examType: { value: [] },
                facility: { value: "" }
            };
            vm.collapse = {};
            assignmentLearnerAccessOnlineExamResource.getAvailableExamSessions({ number: vm.number, version: vm.version, code: vm.code }, function (result) {
                vm.model = result;
                vm.model.examSessionsGroupedByDate = _.groupBy(vm.model.examSessions, function (examSession) {
                    var monthYear = $translate.instant("common.month." + new Date(examSession.startDate).getMonth()) + ", " + new Date(examSession.startDate).getFullYear();
                    vm.collapse[monthYear] = false;
                    return monthYear;
                });
                if (vm.model.examSessions.length > 0) {
                    vm.collapse[Object.keys(vm.collapse)[0]] = true;
                }
                vm.loaded = true;
            }, function (error) {
                messageService.error(error);
                $state.go("main.learningPath.learningItemModal", { number: vm.number, version: vm.version, code: vm.code });
            });
            vm.customFilter = function (examSession) {
                var _a, _b;
                if (examSession) {
                    var examTypeFilter = false;
                    if (vm.filters.examType.value.length > 0)
                        examTypeFilter = _.includes(vm.filters.examType.value, examSession.attendanceType);
                    var cityFilter = false;
                    if (vm.filters.city.value)
                        cityFilter = _.startsWith((_a = examSession.city) === null || _a === void 0 ? void 0 : _a.toLowerCase(), vm.filters.city.value.toLowerCase());
                    var facilityFilter = false;
                    if (vm.filters.facility.value)
                        facilityFilter = _.startsWith((_b = examSession.facilityName) === null || _b === void 0 ? void 0 : _b.toLowerCase(), vm.filters.facility.value.toLowerCase());
                    return (!vm.filters.examType.value.length || examTypeFilter) &&
                        (!vm.filters.city.value || cityFilter) &&
                        (!vm.filters.facility.value || facilityFilter);
                }
                return true;
            };
            vm.viewDetails = function (examSession) {
                $uibModal.open({
                    templateUrl: "app/account/learnerAccess/learningItemType/onlineExamLearnerAccessViewOnlineExamDetailsView.html",
                    scope: $scope,
                    controller: ["examSession", function (examSession) {
                            var vm = this;
                            vm.examSession = examSession;
                            vm.enrollmentView = examSession.isSelfEnrollmentEnabled;
                            vm.singleLanguageSite = frameworkService.data.tenant.enabledLocalizations.length === 1;
                            vm.enroll = function () {
                                vm.enrolling = true;
                                assignmentLearnerAccessOnlineExamResource.enroll({ number: $state.params.number, version: $state.params.version, code: $state.params.code }, { examSessionId: examSession.id }, function () {
                                    messageService.success("learningItem.learnerAccess.exam.enrollmentSuccess");
                                    $state.go("main.learningPath.learningItemModal", { number: $state.params.number, version: $state.params.version, code: $state.params.code });
                                }, function (error) {
                                    messageService.error(error);
                                    vm.enrolling = false;
                                });
                            };
                        }],
                    controllerAs: "vm",
                    resolve: {
                        examSession: examSession
                    }
                }).result.catch(angular.noop);
            };
        }
    });
}());
